import { getPersistenceData, removePersistenceData, setPersistenceData } from "./persistenceStorage";

const visitorTokenKey = "visitorToken";

/**
 * Visitor'ın kimliğini doğrulamak için sunucunun ürettiği gizli token.
 * @returns {string|null}
 */
export const getVisitorToken = () => getPersistenceData(visitorTokenKey, null);

/**
 * Token, visitorId ile aynı yerlerde saklanır (cookie + localStorage). Aksi halde
 * localStorage'ın kullanılamadığı tarayıcılarda visitorId kalıcı olurken token
 * kaybolur ve her yüklemede kimlik doğrulaması başarısız olur.
 * @param {string} token
 */
export const setVisitorToken = (token) => {
    if (!token) return;
    setPersistenceData(visitorTokenKey, token);
};

export const clearVisitorToken = () => {
    removePersistenceData(visitorTokenKey);
};

/**
 * Sunucuya widget'ın token akışını desteklediğini bildirir. Bayrağı göndermeyen
 * eski widget sürümleri geçiş döneminde token'sız kabul edilir.
 */
export const VISITOR_TOKEN_SUPPORTED = true;



// WEBPACK FOOTER //
// ./src/utils/visitorToken.js